// extracted by mini-css-extract-plugin
export default {"modal-overlay":"Modal_modal-overlay__S8CIM","modal-content":"Modal_modal-content__pySKB","modal-close":"Modal_modal-close__hFROZ"};